import ITRADE_EXT_1 from "./ITRADE_EXT_1";
export default {
  ITRADE_EXT_1,
};
